<div class="field-container">
  @if (props['label']) {
  <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
  <label class="field-label">
    {{ props['label'] }}
    @if (props['required']) {
    <span class="required-indicator"> (required)</span>
    }
  </label>
  }

  @if (props['description']) {
  <p class="field-description">{{ props['description'] }}</p>
  }

  @if (isLoading) {
  <div class="loading-state">
    <app-spinner [diameter]="20"></app-spinner>
    <span>Loading options...</span>
  </div>
  } @else if (checkboxOptions.length === 0) {
  <div class="empty-state">
    <app-icon name="info" />
    <p>{{ emptyStateMessage }}</p>
  </div>
  } @else {
  <div class="checkbox-group">
    @for (option of checkboxOptions; track option.value) {
    <div class="checkbox-row">
      <label class="checkbox-item" [class.selected]="isSelected(option.value)">
        <input type="checkbox" [checked]="isSelected(option.value)" (change)="toggleValue(option.value, $event)"
          class="checkbox-input" />
        <div class="option-content">
          <span class="option-label">{{ option.label }}</span>
          @if (option.description) {
          <span class="option-description">{{ option.description }}</span>
          }
        </div>
      </label>
      @if (actionButtons.length > 0) {
      <div class="action-buttons">
        @for (button of actionButtons; track button.icon) {
        @if (shouldShowButton(button, option.value)) {
        <app-button variant="outlined" type="button" (click)="handleActionClick(button, option)">
          <app-icon [name]="button.icon" />
          {{ button.label }}
        </app-button>
        }
        }
      </div>
      }
    </div>
    }
  </div>
  }

  @if (formControl.touched && formControl.errors) {
  <div class="field-error">
    @if (formControl.errors['required']) {
    <span>{{ 'field.validation.required' | translate }}</span>
    }
  </div>
  }
</div>